import type { LegacyLocatesWidgetBlockerModel } from '.';
import { inject, injectable } from 'src/features/ioc';
import { showLegacyLocatesWidgetBlocker } from 'src/lib/featureFlags/flags/showLegacyLocatesWidgetBlocker';
import { getRootUser, getUser } from 'src/store/selectors/auth';
import type { ReactBindings } from 'src/types/bindings';

@injectable()
export class LegacyLocatesWidgetBlockerModelImpl implements LegacyLocatesWidgetBlockerModel {
    readonly blocked;
    readonly #featureFlags: ReactBindings['FeatureFlagService'];
    readonly #store: ReactBindings['Store'];
    readonly #log: ReactBindings['Logger'];

    constructor(
        @inject('FeatureFlagService') featureFlags: ReactBindings['FeatureFlagService'],
        @inject('Store') store: ReactBindings['Store'],
        @inject('Logger') logger: ReactBindings['Logger'],
    ) {
        this.#featureFlags = featureFlags;
        this.#store = store;
        this.#log = logger.getSubLogger({ name: 'LegacyLocatesWidgetBlocker' }, { component: 'lab' });
        this.blocked = featureFlags.getSignal(showLegacyLocatesWidgetBlocker);
    }

    confirmEmergencyAccess(tabId: string): void {
        if (!this.blocked.value) return;

        const state = this.#store.getState();
        this.#log.fatal('LAB v1 emergency widget access confirmed', {
            flagKey: showLegacyLocatesWidgetBlocker.key,
            tabId,
            userId: getUser(state)?.id,
            rootUserId: getRootUser(state)?.id,
        });
        this.#featureFlags.setOverride(showLegacyLocatesWidgetBlocker.key, false);
    }
}
